"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "ak": 4,
    "ar": 7,
    "ay": 10,
    "az": 11,
    "cr": 26,
    "et": 40,
    "fa": 42,
    "ff": 43,
    "gn": 52,
    "ik": 69,
    "iu": 74,
    "kg": 81,
    "kr": 89,
    "ku": 91,
    "kv": 92,
    "lv": 103,
    "mg": 104,
    "mn": 109,
    "ms": 112,
    "ne": 118,
    "no": 122,
    "oj": 127,
    "om": 128,
    "or": 129,
    "ps": 134,
    "qu": 136,
    "sc": 143,
    "sh": 147,
    "sq": 154,
    "sw": 160,
    "uz": 178,
    "yi": 185,
    "za": 187,
    "zh": 188,
    "bal": 721,
    "bik": 919,
    "bnc": 1038,
    "bua": 1209,
    "chm": 1460,
    "del": 1764,
    "den": 1766,
    "din": 1818,
    "doi": 1897,
    "gba": 2248,
    "gon": 2446,
    "grb": 2468,
    "hai": 2579,
    "hmn": 2658,
    "jrb": 3046,
    "kln": 3360,
    "kok": 3433,
    "kpe": 3450,
    "lah": 3734,
    "luy": 4048,
    "man": 4084,
    "mwr": 4634,
    "raj": 5821,
    "rom": 5928,
    "syr": 6481,
    "tmh": 6754,
    "zap": 8067,
    "zza": 8238
};
//# sourceMappingURL=macrolanguage.json.js.map